import React, { Component } from 'react'
import _ from 'lodash';

export default class CreateCrierialModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groupId: '',
            groupName: '',
        };
    }
    elementInfiniteLoad() {
        return (
            <div className='col-sm-4 popup-content'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    addOptions=(data)=>{
        let options =[];
        data.map(item=>{
            options.push(<option key={item.groupId} value={item.groupId}>{item.groupName}</option>)
        })
        return options
    }

    onOptionsSelect = (e) => {
        if(e.target.value!=="select"){
            this.props.getCustomerGroupsData.map(item=>{
                if(e.target.value === item.groupId){
                    this.setState({
                        groupId: e.target.value,
                        groupName: item.groupName
                    },()=>this.onCheckGroupNameExsist(this.state.groupId))
                }
            })
        }else{
            this.setState({
                groupId: '',
                groupName: ''
            })
        }
    }

    onCheckGroupNameExsist=(groupId)=>{
        
        if(!this.props.attractivnessFetching && this.props.attractivnessData.Count!==0 && this.props.attractivnessData.Items[0].attractivness.length>0){
            let exsist = _.find(this.props.attractivnessData.Items[0].attractivness, { 'groupId': groupId});
            this.setState({
                groupNameExist: exsist
            })
        }
    }

    render() {

        let step = "1";
        if(!this.props.attractivnessFetching && this.props.attractivnessData.Count!==0){
            step = 2
        }
        
        return (
            <div className='opacity-overlay ' style={{ 'display': 'block' }}>
                <div className="container">
                    <div className="popup-wrapper">
                        { this.props.getCustomerGroupsFetching 
                            // || this.props.benefits.addGroupFetching
                            &&  this.elementInfiniteLoad()}
                        { !this.props.getCustomerGroupsFetching
                            // || this.props.benefits.addGroupFetching
                        &&
                            <div className="col-xs-12 col-sm-4 popup-content">
                                <div>
                                    <div className='modal-header'>
                                        <h5 className="text-center" style={{width: "100%"}}>Add Customer Group</h5>
                                    </div>
                                    <div className='modal-body'>
                                        {!this.state.groupNameExist &&<h5>Select Customer Group from the list:</h5>}
                                        {this.state.groupNameExist &&<h5>You can not add that Customer Group as it already exists.</h5>}
                                        <div className="row">
                                            {!this.state.groupNameExist && 
                                                <div className="col-md-9">
                                                    <div className="form-group">
                                                        <select className="form-control" style={{height: "34px"}}  onChange={(e)=>this.onOptionsSelect(e)}>
                                                            <option value="select">Select</option>
                                                            {this.props.getCustomerGroupsData.length>0  && this.addOptions(this.props.getCustomerGroupsData)}
                                                        </select>
                                                    </div>
                                                </div>
                                            }
                                            {!this.state.groupNameExist && <div className="col-md-3">
                                                <div className="form-group">
                                                    <button type="button" className="form-control" disabled={this.state.groupId==='' || this.state.groupName===''} onClick={()=>this.props.createCriterialTab({groupId:this.state.groupId, groupName: this.state.groupName},step)}>Add</button>
                                                </div>
                                            </div>}
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <button type="button" className="form-control" onClick={()=>this.props.createCriterialModalClose()}>Close</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>


        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SegmentAttractiveness/Criteria/CreateCrierialModal/CreateCrierialModal.jsx